module.exports = __webpack_public_path__ + "static/img/07.6b26312.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/inno/07.jpg
// module id = 402
// module chunks = 1